import React, { useState, useEffect, useRef, useContext } from "react";
import ContactCard from "./components/ContactCard";
import "./App.css";
import NavBar from "./components/NavBar";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { IoIosClose } from "react-icons/io";
import { FaSass } from "react-icons/fa";
import { FaReact } from "react-icons/fa";
import { FaCss3 } from "react-icons/fa";
import { FaWordpress } from "react-icons/fa";
import { FaPython } from "react-icons/fa";
import { SiFlask } from "react-icons/si";
import { IoLogoJavascript } from "react-icons/io5";
import { DiSqllite } from "react-icons/di";
import { FaGithub } from "react-icons/fa";
import { TbScreenShare } from "react-icons/tb";
import { ThemeContext } from "./context/themeContext";
import { IoLogoFirebase } from "react-icons/io5";
import { FaBootstrap } from "react-icons/fa";
import { SplitText } from "gsap/SplitText";
import { DeviceWidthContext } from "./context/deviceWidthContext";
import { FaRegCopyright } from "react-icons/fa6";
import { IoLogoElectron } from "react-icons/io5";
import Gallery from "./components/Gallery";

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(SplitText);
function App() {
  const { deviceWidth } = useContext(DeviceWidthContext);

  const [yearOfExperience, setYearOfExperience] = useState(3);
  const [width, setWidth] = useState();
  const [imgIndex, setImgIndex] = useState(0)
  const [scrollYPosition, setScrollYPosition] = useState(0);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [animationTarget, setAnimationTarget] = useState(null);
  const [mouseMoving, setMouseMoving] = useState(false);
  const [hideNav, setHideNav] = useState(false);
  const ringTimerRef = useRef(null);
  const navTimerRef = useRef(null);
  const contactRing = "Contact • Contact • Contact • Contact •";
  const [lang, setLang] = useState("en");

  const [cursorPosition, setCursorPosition] = useState({
    cursorX: 0,
    cursorY: 0,
  });

  const [imgMockup, setImgMockup] = useState();

  const container = useRef();
  const projectsRef = useRef();

  const projectRefs = useRef([]);
  const blobRef = useRef();
  const contentRef = useRef();
  const cursorRef = useRef();
  const [cursorY, setCursorY] = useState(0)
  const [cursorX, setCursorX] = useState(0)

  const tl = useRef();

  const { darkTheme } = useContext(ThemeContext);

  const { contextSafe } = useGSAP({ scope: container });

  const langOptions = {
    navItems: {
      en: ["about", "projects", "contact"],
      fr: ["à propos", "réalisations", "contact"],
    },
    about: {
      en: "Web developer crafting simple, efficient solutions with curiosity and care.",
      fr: "Développeuse web, je crée des solutions simples et efficaces, guidée par la curiosité et le soin du détail.",
    },
    info: {
      en: [
        `${yearOfExperience}+ years experience`,
        "Software Developer",
        "Based in France",
      ],
      fr: [
        `${yearOfExperience}+ ans d'expérience`,
        "Développeuse web",
        "Basée en France",
      ],
    },
    contact: {
      en: "Contact me",
      fr: "Me contacter",
    },
  };

  const projects = [
    {
      id: 1,
      name: "Jungle App",
      website_url: "https://ouadjet2807.github.io/jungle-app/",
      git_url: "https://github.com/Ouadjet2807/jungle-app",
      description_fr:
        "Un petit projet React : catalogue de plantes avec gestion des favoris via localStorage.",
      description_en:
        "A small React project : plants catalog with favorites management through localStorage",
      img: "Assets/jungle-app.jpg",
      img_mockup: ["Assets/jungle-app-mockup.png"],
      stack: ["React", "Sass"],
    },
    {
      id: 2,
      name: "E-commerce product page Challenge",
      website_url:
        "https://ouadjet2807.github.io/frontEndMentor_ecommerce_product_page/",
      git_url:
        "https://github.com/Ouadjet2807/frontEndMentor_ecommerce_product_page.git",
      description_fr:
        "Une page de produit d'un site E-commerce, dans le cadre d'un challenge Front-End Mentor",
      description_en:
        "A product page of an E-commerce website made during a Front-End Mentor challenge",
      img: "Assets/FrontEndMentorEcommerce.jpg",
      img_mockup: ["Assets/FrontEndMentorEcommerce-mockup.png"],
      stack: ["React", "Sass"],
    },
    {
      id: 3,
      name: "Rock-Paper-Scissors-Lizard-Spock Challenge",
      website_url:
        "https://ouadjet2807.github.io/frontEndMentor_RockPaperScissors/",
      git_url:
        "https://github.com/Ouadjet2807/frontEndMentor_RockPaperScissors",
      description_fr:
        'Une version du célèbre "Pierre-Feuille-Ciseaux(-Lézard-Spock)", dans le cadre d\'un challenge Front-End Mentor',
      description_en:
        'A version of the famous "Rock-Paper-Scissors(-Lizard-Spock)" made during a Front-End Mentor challenge',
      img: "Assets/FrontEndMentorRPSLS.jpg",
      img_mockup: ["Assets/FrontEndMentorRPSLS-mockup.png"],
      stack: ["React", "Sass"],
    },
    {
      id: 4,
      name: "Éveilles tes sens",
      website_url: "http://xn--veilles-tes-sens-9pb.fr/",
      git_url: "",
      description_fr:
        "Site vitrine pour une praticienne en Reiki, massage de Breuss et réflexologie.",
      description_en:
        "Showcase site for a Reiki, Breuss massage and reflexology practicionner",
      img: "Assets/ets.jpg",
      img_mockup: "Assets/ets-mockup.png",
      stack: ["Wordpress", "CSS"],
    },
    {
      id: 5,
      name: "Husson TP",
      website_url: "https://hussontp.fr/",
      git_url: "",
      description_fr:
        "Site vitrine pour une entreprise de terrassement, réaliser dans le cadre d'un stage",
      description_en:
        "Showcase site that I built during an internship for an Earthmoving company",
      img: "Assets/husson.jpg",
      img_mockup: ["Assets/husson-tp-mockup.png"],
      stack: ["Wordpress", "CSS"],
    },
    {
      id: 6,
      name: "ReminiDEX",
      website_url: "https://reminidex.onrender.com/login",
      git_url: "https://github.com/Ouadjet2807/ReminiDEX.git",
      description_fr:
        "Application web de Flashcards, projet final du cours \"CS50's Introduction to Computer Sciences\" d'HarvardX",
      description_en:
        "Flashcards application I built as the final project of HarvardX's CS50's Introduction to Computer Sciences",
      img: "Assets/ReminiDEX.jpg",
      img_mockup: ["Assets/ReminiDEX-mockup.png"],
      stack: ["Python", "JavaScript", "Sass", "Flask", "Sqlite", "Bootstrap"],
    },
    {
      id: 7,
      name: "Action RSE",
      website_url: "https://ouadjet2807.github.io/rse/",
      git_url: "https://github.com/Ouadjet2807rse.git",
      description_fr: "Site dédié à la RSE",
      description_en: "Website about RSE",
      img: "Assets/ActionRSE.jpg",
      img_mockup: ["Assets/ActionRSE-mockup.png"],
      stack: ["React", "Sass", "Firebase"],
    },
    {
      id: 8,
      name: "Weather Forecast",
      website_url: "",
      git_url: "https://github.com/Ouadjet2807/electron-weather-app.git",
      description_fr:
        "Application météo inspirée des chaines météo des années 80-90",
      description_en:
        "Weather forecast application inspired by late 80's weather channels",
      img: "Assets/wf.jpg",
      img_mockup: ["Assets/wf-mockup.webm", "Assets/wf-closeup.webm", "Assets/wf.jpg", "Assets/wf-detailed.jpg"],
      stack: ["React", "Sass", "Electron"],
    },
  ];

  const calculateExperience = () => {
    let start = new Date("07/01/2022");
    let lastExperienceDate = new Date("08/31/2025");
    // let today = new Date();

    setYearOfExperience(lastExperienceDate.getFullYear() - start.getFullYear());
  };

  const getCursorPosition = (e) => {
    if (!mouseMoving) {
      setMouseMoving(true);
      setHideNav(true);
    }
    setCursorX(e.clientX)
    setCursorY(e.clientY)
    // cursorX.current = e.clientX
    // cursorY.current = e.clientY
  };

  const renderTechSymbol = (tech) => {
    switch (tech) {
      case "Sass":
        return <FaSass />;
      case "React":
        return <FaReact />;
      case "CSS":
        return <FaCss3 />;
      case "Wordpress":
        return <FaWordpress />;
      case "Python":
        return <FaPython />;
      case "JavaScript":
        return <IoLogoJavascript />;
      case "Flask":
        return <SiFlask />;
      case "Sqlite":
        return <DiSqllite />;
      case "Firebase":
        return <IoLogoFirebase />;
      case "Bootstrap":
        return <FaBootstrap />;
      case "Electron":
        return <IoLogoElectron />;
      default:
        break;
    }
  };

  const selectProject = (e, index) => {
    setSelectedProject(index + 1);
    setImgMockup(projects[index].img_mockup);
  };

  const deselectProject = contextSafe((e) => {
    e.stopPropagation();
    setSelectedProject(null);
    projects.forEach((i) => {
      let id = i.id;

      gsap.to(`.projects`, {
        gridTemplateColumns: "31% 31% 31%",
      });
      gsap.to(`#project_${id} .right .imgBox`, {
        backgroundImage: `url(${i.img})`,
      });
    });
  });

  const resetDragging = () => {
    if(selectedProject) return

    setIsDragging(false)
  }

  const handleMouseDown = (e) => {
    if (selectedProject) return;
    const el = projectsRef.current;
    setIsDragging(true);
    setStartX(e.pageX - el.offsetLeft);
    setScrollLeft(el.scrollLeft);
  };
  
  const handleMouseMove = (e) => {
    if (!isDragging || selectedProject) return;
    e.preventDefault();
    const el = projectsRef.current;
    const x = e.pageX - el.offsetLeft;
    const walk = (x - startX) * 2; // scroll speed multiplier
    el.scrollLeft = scrollLeft - walk;
  };

  const handleAnimationTarget = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setAnimationTarget(e);

    if (e.type === "mouseleave") {
      setTimeout(() => {
        setAnimationTarget();
      }, 1000);
    }
  };

  useGSAP(() => {
    let color = "";

    let button = animationTarget ? animationTarget.target.id : "";
    if (!button) return;

    if (animationTarget && animationTarget.type === "mouseenter") {
      color = darkTheme ? "#222" : "#f5f5f5";

      gsap.timeline().to(".cursor .custom-cursor", {
        border: `1px solid ${color}`,
        ease: "power3.inOut",
      });
      gsap.to(`#${button} .calc`, {
        transformOrigin: "left",
        scaleX: 1,
        opacity: 1,
        ease: "power1.inOut",
        duration: 0.2,
      });
      gsap.to(`#${button} a`, {
        color: color,
        ease: "power3.out",
        duration: 0.2,
      });
      gsap.to(`#${button}`, {
        border: `2px solid ${color}`,
        ease: "power3.out",
        duration: 0.2,
      });
    } else {
      color = darkTheme ? "#f5f5f5" : "#222";
      gsap.timeline().to(".cursor .custom-cursor", {
        border: `1px solid ${color}`,
      });
      gsap.to(`.project-button .calc`, {
        ease: "power1.inOut",
        transformOrigin: "left",
        opacity: 0,
        scaleX: "0",
        duration: 0.2,
      });
      gsap.to(`.project-button a`, {
        color: color,
        ease: "power3.out",
        duration: 0.2,
      });
      gsap.to(`.project-button`, {
        border: `2px solid ${color}`,
        ease: "power3.out",
        duration: 0.2,
      });
    }

    tl.current = gsap;
  }, [animationTarget]);

  useGSAP(
    () => {
      if (selectedProject) {
        gsap.to(`.project`, {
          transition: "0s ease-in",
        });
        gsap.to(`.project:not(.selected)`, {
          y: 80,
          scale: 0,
        });
        gsap.to(`.project.selected`, {
          y: -80,
          position: "absolute",
          display: "grid", 
          height: "40vw",
          marginTop: "7vw",
          boxShadow: "none",
        });
        gsap.to(`.project.selected .info span`, {
          width: "80%",
          fontSize: "2.5vw",
          marginBottom: "5vh",
        });
      }
    },
    { dependencies: selectedProject },
  );

  useGSAP(() => {
    const quickX = gsap.quickTo(cursorRef.current, "x", {
      duration: 0.2,
      ease: "power3.out",
    });
    const quickY = gsap.quickTo(cursorRef.current, "y", {
      duration: 0.2,
      ease: "power3.out",
    });

    const moveCursor = contextSafe((e) => {
      quickX(e.clientX);
      quickY(e.clientY);
    });

    const scaleUp = contextSafe(() => {
      gsap.to(cursorRef.current, {
        scale: 0.7,
        duration: 0.2,
        ease: "power2.out",
      });
    });

    const scaleDown = contextSafe(() => {
      gsap.to(cursorRef.current, {
        scale: 1,
        duration: 0.2,
        ease: "power2.out",
      });
    });

    const hoverTargets = document.querySelectorAll(".hover-target");
    console.log(hoverTargets);
    hoverTargets.forEach((el) => {
      console.log(el);
      
      if(el.className.includes("project") && selectedProject) return
      el.addEventListener("mouseenter", scaleUp);
      el.addEventListener("mouseleave", scaleDown);
    });

    window.addEventListener("mousemove", moveCursor);

    return () => {
      window.removeEventListener("mousemove", moveCursor);
      hoverTargets.forEach((el) => {
        el.removeEventListener("mouseenter", scaleUp);
        el.removeEventListener("mouseleave", scaleDown);
      });
    };
  }, []);

  useGSAP(() => {
    if (darkTheme) {
      gsap.to(`.buttons button a`, {
        color: "#f5f5f5",
        ease: "power3.out",
        duration: 0.2,
      });
      gsap.to(`.buttons button`, {
        border: "2px solid #f5f5f5",
        ease: "power3.out",
        duration: 0.2,
      });
    } else {
      gsap.to(`.buttons button a`, {
        color: "#222",
        ease: "power3.out",
        duration: 0.2,
      });
      gsap.to(`.buttons button`, {
        border: "2px solid #222",
        ease: "power3.out",
        duration: 0.2,
      });
    }
  }, [darkTheme]);

  useGSAP(
    () => {
      let splitHero = SplitText.create(".about", { type: "words, chars" });

      gsap.from(splitHero.chars, {
        duration: 0.8,
        y: 100,
        autoAlpha: 0,
        stagger: 0.02,
      });
    },
    { dependencies: lang },
  );

  useEffect(() => {
    const projects = projectsRef.current;

    if (!selectedProject) {
      const handleWheel = (e) => {
        const { scrollLeft, scrollWidth, clientWidth } = projects;

        const atStart = scrollLeft <= 0;
        const atEnd = scrollLeft + clientWidth >= scrollWidth;

        if (!atStart || !atEnd) {
          if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
            return;
          }

          e.preventDefault();
          projects.scrollLeft += e.deltaY;
        }
      };

      projects.addEventListener("wheel", handleWheel, { passive: false });

      return () => projects.removeEventListener("wheel", handleWheel);
    }
  }, [selectedProject]);

  useEffect(() => {
    calculateExperience();

    const el = contentRef.current;

    const handleScroll = () => {
      setScrollYPosition(el.scrollTop);
    };

    el.addEventListener("scroll", handleScroll);

    return () => {
      el.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    clearTimeout(ringTimerRef.current);
    clearTimeout(navTimerRef.current);

    ringTimerRef.current = setTimeout(() => {
      setMouseMoving(false);
    }, 300);

    navTimerRef.current = setTimeout(() => {
      setHideNav(false);
    }, 8000);
  }, [mouseMoving])



  return (
    <div
      className="App"
      ref={container}
      onMouseMove={(e) => getCursorPosition(e)}
    >
      <NavBar
        scrollYPosition={scrollYPosition}
        lang={lang}
        setLang={setLang}
        langOptions={langOptions}
        hideNav={hideNav}
      />
      <div ref={cursorRef} className="cursor">
        <div className="custom-cursor"></div>
      </div>
      <div ref={blobRef} className="blob"></div>
      <div className="overlay"></div>
      <div className="content" ref={contentRef}>
        <div
          className="title-anchor"
          id={`${lang === "en" ? "about" : "à-propos"}-section`}
        ></div>
        <div
          className="title"
          id={`${lang === "en" ? "about" : "à-propos"}-section`}
        >
          {deviceWidth > 800 ? (
            <h1>Hello, I'm Nina Socrate</h1>
          ) : (
            <h1>
              Hello,
              <br /> I'm Nina Socrate
            </h1>
          )}

          <p className="about">{langOptions.about[lang]}</p>
        </div>
        <div
          className="projects-anchor"
          id={`${lang === "en" ? "projects" : "réalisations"}-section`}
        ></div>
        <div className="projects_section">
          <h2>{lang === "fr" ? "Projets" : "Projects"}</h2>
          <div
            className={`projects ${selectedProject ? "active" : ""}`}
            ref={projectsRef}
            onMouseLeave={() => resetDragging()}
            onMouseUp={() => resetDragging()}
            onMouseDown={(e) => handleMouseDown(e)}
            onMouseMove={(e) => handleMouseMove(e)}
          >
            {projects.map((item, index) => (
              <div
                className={`project ${
                  selectedProject === index + 1 ? "selected" : "hover-target"
                } `}
                id={`project_${index + 1}`}
                ref={(el) => (projectRefs.current[index] = el)}
                onClick={(e) => selectProject(e, index)}
              >
                <div className="right">
                  {selectedProject !== null && (
                    <div
                      className="close hover-target"
                      onClick={(e) => deselectProject(e, index)}
                    >
                      <IoIosClose />
                    </div>
                  )}
                 <Gallery projectId={index} imgMockup={imgMockup} selectedProject={selectedProject} img={item.img}/>
                </div>
                <div className="info">
                  <span className="project_title">{item.name}</span>
                  <div className="stack">
                    {item.stack.map((tech) => {
                      return (
                        <div className="tech" id={tech} title={tech}>
                          {renderTechSymbol(tech)}
                        </div>
                      );
                    })}
                  </div>
                  {selectedProject !== null && (
                    <>
                      <p className="description">
                        {item[`description_${lang}`]}
                      </p>
                      <div
                        className="buttons"
                        style={{
                          gridTemplateColumns: `${
                            item.git_url !== "" ? "50% 50%" : "100%"
                          }`,
                        }}
                      >
                        {item.website_url && (
                          <button
                            className="hover-target project-button"
                            id="visit_website"
                            onMouseEnter={(e) => handleAnimationTarget(e)}
                            onMouseLeave={(e) => handleAnimationTarget(e)}
                          >
                            <a href={item.website_url} target="_blank">
                              {lang == "en" ? "See" : "Voir"} <TbScreenShare />
                            </a>
                            <div className="calc"></div>
                          </button>
                        )}
                        {item.git_url && (
                          <button
                            className="hover-target project-button"
                            id="visit_repo"
                            onMouseEnter={(e) => handleAnimationTarget(e)}
                            onMouseLeave={(e) => handleAnimationTarget(e)}
                          >
                            <a href={item.git_url} target="_blank" className="hover-target">
                              GitHub <FaGithub />
                            </a>
                            <div className="calc hover-target"></div>
                          </button>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="infoSection">
          {langOptions.info[lang].map((item) => {
            return <span className="item">{item}</span>;
          })}
        </div>
        <div className="contact" id="contact-section">
          <ContactCard lang={lang} langOptions={langOptions} />
          <div
            className={`spinning-ring-box ${mouseMoving ? "moving" : "idle"}`}
            style={{
              top: `${cursorY}px`,
              left: `${cursorX}px`,
            }}
          >
            <div className="ring">
              <div className="small-circle">Get in touch</div>
              <div className="text">
                {contactRing.split("").map((item, index) => (
                  <span style={{ transform: `rotate(${index * 9}deg)` }}>
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
        <p className="footer">
          Nina Socrate - <FaRegCopyright /> {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}

export default App;
